import { TrendingUp, Trophy, BookOpen } from "lucide-react"

interface ClassStatsCardsProps {
  classAverage: number
  topPerformer: string
  subjectsTaken: number
}

export function ClassStatsCards({ classAverage, topPerformer, subjectsTaken }: ClassStatsCardsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      <div className="bg-white p-6 rounded-3xl border border-slate-100 shadow-sm flex items-center gap-5">
        <div className="w-12 h-12 rounded-2xl bg-green-100 text-green-600 flex items-center justify-center">
          <TrendingUp className="w-6 h-6" />
        </div>
        <div>
          <p className="text-sm text-slate-500 font-medium">Class Average</p>
          <h3 className="text-2xl font-bold text-slate-800">{classAverage}%</h3>
        </div>
      </div>

      <div className="bg-white p-6 rounded-3xl border border-slate-100 shadow-sm flex items-center gap-5">
        <div className="w-12 h-12 rounded-2xl bg-indigo-100 text-indigo-600 flex items-center justify-center">
          <Trophy className="w-6 h-6" />
        </div>
        <div>
          <p className="text-sm text-slate-500 font-medium">Top Performer</p>
          <h3 className="text-lg font-bold text-slate-800">{topPerformer}</h3>
        </div>
      </div>

      <div className="bg-white p-6 rounded-3xl border border-slate-100 shadow-sm flex items-center gap-5">
        <div className="w-12 h-12 rounded-2xl bg-blue-900/10 text-blue-900 flex items-center justify-center">
          <BookOpen className="w-6 h-6" />
        </div>
        <div>
          <p className="text-sm text-slate-500 font-medium">Subjects Taken</p>
          <h3 className="text-2xl font-bold text-slate-800">{subjectsTaken}</h3>
        </div>
      </div>
    </div>
  )
}
